// extracted by css-extract-rspack-plugin
export default {"sidebar":"PullRequestFileTree-module__sidebar__PJ8nx","FileTreeScrollable":"PullRequestFileTree-module__FileTreeScrollable__OW_Y2"};